import Vue from "vue";

import VueMathjax from "vue-mathjax";

Vue.use(VueMathjax);

export default VueMathjax;
